import React, { useState } from "react";
import CommonLayout from "../../../../Components/CommonLayout/CommonLayout";
import TogglesList from "../../components/TogglesList";
import AdminSettings from "./AdminSettings";
import AppSettings from "./AppSettings";
import GoogleKeySettings from "./GoogleKeySettings";
import NotificationSetting from "./NotificationSetting";
import ConfigurationSettings from "./ConfigurationSettings";
import UpdateAppSettings from "./UpdateAppSettings";
import SiteSettings from "./SiteSettings";
import PaymentGateway from "./PaymentGateway";
const Admin = ({meta}) => {
  const [activeToggle, setActiveToggle] = useState("Admin Settings");
  const toggleJson = [
    "Admin Settings",
    "Site Settings",
    "Payment Gateway",
    // "Notifications Settings",
    // "Configuration Settings",
    // "Update App Settings",
  ];
  return (
    <div style={{ padding: "1rem", marginBottom: "8rem" }}>
      <CommonLayout />
      <TogglesList
        data={toggleJson}
        active={activeToggle}
        setActiveToggle={setActiveToggle}
      />
      {activeToggle == "Admin Settings" && <AdminSettings />}
      {activeToggle == "Site Settings" && < SiteSettings/>}
      {activeToggle == "Payment Gateway" && <PaymentGateway/>}
      {/* {activeToggle == "Google Key Settings" && < GoogleKeySettings/>} */}
      {/* {activeToggle == "Notifications Settings" && <NotificationSetting />}
      {activeToggle == "Configuration Settings" && <ConfigurationSettings />}
      {activeToggle == "Update App Settings" && <UpdateAppSettings />} */}
    </div>
  );
};

export default Admin;
